import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "@/components/icon/Icon";
const InvitationSentModal = (props) => {
  const { onClose, title } = props;
  const { t } = useTranslation();
  return /* @__PURE__ */ React.createElement("div", { className: "invitation-sent-modal" }, /* @__PURE__ */ React.createElement("div", { className: "modal-confirmation__top" }, /* @__PURE__ */ React.createElement("button", { className: "modal-confirmation__close", onClick: onClose }, t("modal.close"), /* @__PURE__ */ React.createElement(Icon, { icon: "xSolo" }))), /* @__PURE__ */ React.createElement("div", { className: "modal-confirmation__content" }, /* @__PURE__ */ React.createElement("h1", { className: "modal-confirmation__header" }, title)));
};
export default InvitationSentModal;
